import { render, staticRenderFns } from "./GuestReservations.vue?vue&type=template&id=f6e533a4&scoped=true&"
import script from "./GuestReservations.vue?vue&type=script&lang=ts&"
export * from "./GuestReservations.vue?vue&type=script&lang=ts&"
import style0 from "./GuestReservations.vue?vue&type=style&index=0&id=f6e533a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e533a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
